import { StorageTokensConfig } from './types/main';

let storageTokensConfig: StorageTokensConfig = {
    heartBeat: undefined,
    runOnce: undefined,
    showLogs: undefined,
};

export const setupStorageTokensConfig = (data: Partial<StorageTokensConfig>): void => {
    storageTokensConfig = {
        ...storageTokensConfig,
        ...data,
    };
};

export const getStorageTokensConfig = (): StorageTokensConfig => storageTokensConfig;
